import { render, staticRenderFns } from "./MppGradeTeam.vue?vue&type=template&id=ec3d8d2c&scoped=true"
import script from "./MppGradeTeam.vue?vue&type=script&lang=js"
export * from "./MppGradeTeam.vue?vue&type=script&lang=js"
import style0 from "./MppGradeTeam.vue?vue&type=style&index=0&id=ec3d8d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3d8d2c",
  null
  
)

export default component.exports